import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core'
import { DemandByDistance, DemandByDistances } from '../types/DemandByDistances';
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { saveAs } from 'file-saver';
import { DxDataGridComponent } from 'devextreme-angular';
import { LocationSnapshotFilters } from '../types/LocationSnapshotFilters';

@Component({
  selector: 'demand-by-distance',
  templateUrl: './demand-by-distance.component.html'
})
export class DemandByDistanceComponent implements OnInit, OnChanges {
  @ViewChild('totalPotentialLOXLINVolumeGrid', { static: true }) totalPotentialLOXLINVolumeGrid: DxDataGridComponent;
  @ViewChild('potentialLOXLINVolumeGrid', { static: true }) potentialLOXLINVolumeGrid: DxDataGridComponent;
  @ViewChild('totalPotentialLOXLINVolumeNonAPGrid', { static: true }) totalPotentialLOXLINVolumeNonAPGrid: DxDataGridComponent;
  @ViewChild('potentialLOXLINVolumeNonAPGrid', { static: true }) potentialLOXLINVolumeNonAPGrid: DxDataGridComponent;

  header1: string;
  header2: string;
  header3: string;
  header4: string;
  header5: string;
  header6: string;
  chooserMode: string = 'select';

  _demandByDistances: DemandByDistance[][];
  @Input()
  set demandByDistances(value: DemandByDistance[][]) {
    this._demandByDistances = value;
  }

  get demandByDistances(): DemandByDistance[][] {
    return this._demandByDistances;
  }

  @Input() filters: LocationSnapshotFilters;

  constructor() {

  }

  exportExcel_TotalPotentialLOXLINVolume(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('TotalPotentialLOXLINVolume');
    exportDataGrid({
      component: this.totalPotentialLOXLINVolumeGrid.instance,
      worksheet: worksheet
    }).then(function () {
      workbook.xlsx.writeBuffer()
        .then(function (buffer: BlobPart) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'TotalPotentialLOXLINVolume.xlsx');
        });
    });
    e.cancel = true;
  }


  exportExcel_PotentialLOXLINVolume(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('PotentialLOXLINVolume');
    exportDataGrid({
      component: this.potentialLOXLINVolumeGrid.instance,
      worksheet: worksheet
    }).then(function () {
      workbook.xlsx.writeBuffer()
        .then(function (buffer: BlobPart) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'PotentialLOXLINVolume.xlsx');
        });
    });
    e.cancel = true;
  }

  exportExcel_TotalPotentialLOXLINVolumeNonAP(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('TotalPotentialLOXLINVolumeNonAP');
    exportDataGrid({
      component: this.totalPotentialLOXLINVolumeNonAPGrid.instance,
      worksheet: worksheet
    }).then(function () {
      workbook.xlsx.writeBuffer()
        .then(function (buffer: BlobPart) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'TotalPotentialLOXLINVolumeNonAP.xlsx');
        });
    });
    e.cancel = true;
  }


  exportExcel_PotentialLOXLINVolumeNonAP(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('PotentialLOXLINVolumeNonAP');
    exportDataGrid({
      component: this.totalPotentialLOXLINVolumeNonAPGrid.instance,
      worksheet: worksheet
    }).then(function () {
      workbook.xlsx.writeBuffer()
        .then(function (buffer: BlobPart) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'PotentialLOXLINVolumeNonAP.xlsx');
        });
    });
    e.cancel = true;
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges){
    this.setHeaderStrings();
  }

  setHeaderStrings() {
    if (this.filters && this.filters.product) {
      let product = this.filters.product.join(",");
      this.header1 = 'Total Potential ' + product + ' Volume';
      this.header2 = 'AIR PRODUCTS CONFIDENTIAL - INTERNAL USE ONLY';
      this.header3 = 'Potential ' + product + ' Volume After Applying Win Rates';
      this.header4 = "Win Rate totals come from historical lead generation results from 2010-2011 in N. America.  If the 'Total Potential' and 'Potential Volume after WinRate' tables are blank, then there are no competitor plants.";
      this.header5 = 'Total Potential ' + product + ' Volume With AP Accounts Removed';
      this.header6 = 'Potential ' + product + ' Volume After Applying Win Rates With AP Accounts Removed';
    }
  }

}